/*=========================================================
  BR ROOM PLANNER
  Blue Room — Calendario + Formulario + Google Sheets
=========================================================*/


console.log("ROOM PLANNER OK");


/*=========================================================
  GOOGLE APPS SCRIPT
=========================================================*/

const BR_BOOKING_API =
  "https://script.google.com/macros/s/AKfycbzzb1XhSj8xe_I46GhAy-ze8oKsn8qExdAnhjg10l3GAOKjhrdGzj5RxawcBfUspKEdZA/exec";


document.addEventListener(
  "DOMContentLoaded",
  init
);


/*=========================================================
  INIT
=========================================================*/

function init(){

  document
    .querySelectorAll(".br-viewer")
    .forEach(
      initCompare
    );


  document
    .querySelectorAll(".br-calendar")
    .forEach(
      initCalendar
    );

}


/*=========================================================
  BEFORE / AFTER
=========================================================*/

function initCompare(viewer){

  const stage =
    viewer.querySelector(
      ".br-viewer__stage"
    );


  const after =
    viewer.querySelector(
      ".br-viewer__after"
    );


  const divider =
    viewer.querySelector(
      ".br-viewer__divider"
    );


  if(
    !stage ||
    !after ||
    !divider
  ){

    return;

  }


  let dragging = false;


  setPosition(50);


  function setPosition(percent){

    percent =
      Math.max(
        3,
        Math.min(
          97,
          percent
        )
      );


    after.style.width =
      percent + "%";


    divider.style.left =
      percent + "%";

  }


  function update(clientX){

    const rect =
      stage.getBoundingClientRect();


    const percent =
      (
        (clientX - rect.left)
        /
        rect.width
      ) * 100;


    setPosition(
      percent
    );

  }


  /*=======================================================
    DESKTOP
  =======================================================*/

  stage.addEventListener(
    "mousedown",
    function(e){

      dragging = true;


      viewer.classList.add(
        "is-dragging"
      );


      update(
        e.clientX
      );

    }
  );


  window.addEventListener(
    "mousemove",
    function(e){

      if(!dragging){

        return;

      }


      update(
        e.clientX
      );

    }
  );


  window.addEventListener(
    "mouseup",
    function(){

      dragging = false;


      viewer.classList.remove(
        "is-dragging"
      );

    }
  );


  /*=======================================================
    MOBILE
  =======================================================*/

  stage.addEventListener(
    "touchstart",
    function(e){

      dragging = true;


      update(
        e.touches[0].clientX
      );

    },
    {
      passive: true
    }
  );


  window.addEventListener(
    "touchmove",
    function(e){

      if(!dragging){

        return;

      }


      update(
        e.touches[0].clientX
      );

    },
    {
      passive: true
    }
  );


  window.addEventListener(
    "touchend",
    function(){

      dragging = false;


      viewer.classList.remove(
        "is-dragging"
      );

    }
  );

}


/*=========================================================
  CALENDAR
=========================================================*/

function initCalendar(calendar){

  const monthLabel =
    calendar.querySelector(
      ".br-calendar__month"
    );


  const days =
    calendar.querySelector(
      ".br-calendar__days"
    );


  const prev =
    calendar.querySelector(
      ".br-calendar__prev"
    );


  const next =
    calendar.querySelector(
      ".br-calendar__next"
    );


  if(
    !monthLabel ||
    !days ||
    !prev ||
    !next
  ){

    return;

  }


  /*=======================================================
    MESES
  =======================================================*/

  const months = [

    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"

  ];


  /*=======================================================
    FECHA ACTUAL
  =======================================================*/

  let currentDate =
    new Date();


  let month =
    currentDate.getMonth();


  let year =
    currentDate.getFullYear();


  /*=======================================================
    SELECCIÓN
  =======================================================*/

  let selectedDate =
    null;


  let selectedHour =
    null;


  /*=======================================================
    HORARIOS OCUPADOS
  =======================================================*/

  let occupiedHours =
    [];


  /*=======================================================
    BOOKING DATA
  =======================================================*/

  const bookingData = {

    date: null,

    hour: null,

    name: null,

    phone: null,

    email: null,

    product: null,

    variant: null,

    color: null,

    url: window.location.href

  };


  /*=======================================================
    ELEMENTOS BOOKING
  =======================================================*/

  const booking =
    calendar.closest(
      ".br-booking"
    );


  if(!booking){

    return;

  }


  const hoursGrid =
    booking.querySelector(
      ".br-hours__grid"
    );


  const bookingButton =
    booking.querySelector(
      ".br-button"
    );


  const hoursMessage =
    booking.querySelector(
      ".br-hours__selected"
    );


  /*=======================================================
    HORARIOS DISPONIBLES
  =======================================================*/

  const hours = [

    "09:00",
    "09:30",
    "10:00",
    "10:30",
    "11:00",
    "11:30",
    "12:00",
    "12:30",
    "13:00",
    "13:30",
    "14:00",
    "14:30"

  ];


  /*=======================================================
    INICIALIZAR
  =======================================================*/

  render();

  renderHours();

  updateBookingButton();


  /*=======================================================
    MES ANTERIOR
  =======================================================*/

  prev.addEventListener(
    "click",
    function(){

      month--;


      if(month < 0){

        month = 11;

        year--;

      }


      selectedDate =
        null;


      selectedHour =
        null;


      occupiedHours =
        [];


      bookingData.date =
        null;


      bookingData.hour =
        null;


      render();

      renderHours();

      updateBookingButton();

    }
  );


  /*=======================================================
    MES SIGUIENTE
  =======================================================*/

  next.addEventListener(
    "click",
    function(){

      month++;


      if(month > 11){

        month = 0;

        year++;

      }


      selectedDate =
        null;


      selectedHour =
        null;


      occupiedHours =
        [];


      bookingData.date =
        null;


      bookingData.hour =
        null;


      render();

      renderHours();

      updateBookingButton();

    }
  );


  /*=======================================================
    RENDER CALENDARIO
  =======================================================*/

  function render(){

    monthLabel.textContent =
      months[month] +
      " " +
      year;


    days.innerHTML =
      "";


    const firstDay =
      new Date(
        year,
        month,
        1
      );


    const lastDay =
      new Date(
        year,
        month + 1,
        0
      );


    let offset =
      firstDay.getDay();


    offset =
      offset === 0
        ? 6
        : offset - 1;


    /*=====================================================
      ESPACIOS ANTES DEL PRIMER DÍA
    =====================================================*/

    for(
      let i = 0;
      i < offset;
      i++
    ){

      const empty =
        document.createElement(
          "div"
        );


      empty.className =
        "br-day br-day--empty";


      days.appendChild(
        empty
      );

    }


    /*=====================================================
      DÍAS
    =====================================================*/

    for(
      let day = 1;
      day <= lastDay.getDate();
      day++
    ){

      const button =
        document.createElement(
          "button"
        );


      button.type =
        "button";


      button.className =
        "br-day";


      button.textContent =
        day;


      const thisDate =
        new Date(
          year,
          month,
          day
        );


      const today =
        new Date();


      today.setHours(
        0,
        0,
        0,
        0
      );


      const isPastYear =
        year <
        today.getFullYear();


      const isPastMonth =
        year ===
          today.getFullYear() &&
        month <
          today.getMonth();


      const isCurrentMonth =
        year ===
          today.getFullYear() &&
        month ===
          today.getMonth();


      /*===================================================
        DESHABILITAR FECHAS PASADAS
      ===================================================*/

      if(
        isPastYear ||
        isPastMonth ||
        (
          isCurrentMonth &&
          thisDate < today
        )
      ){

        button.classList.add(
          "is-disabled"
        );


        button.disabled =
          true;

      }


      /*===================================================
        SELECCIONAR FECHA
      ===================================================*/

      button.addEventListener(
        "click",
        function(){

          selectedDate =
            thisDate;


          bookingData.date =
            formatDate(
              thisDate
            );


          selectedHour =
            null;


          bookingData.hour =
            null;


          occupiedHours =
            [];


          render();

          renderHours();

          updateBookingButton();


          /*===============================================
            CONSULTAR GOOGLE SHEETS
          ===============================================*/

          loadAvailability();

        }
      );


      /*===================================================
        FECHA ACTIVA
      ===================================================*/

      if(
        selectedDate &&
        selectedDate.getTime() ===
        thisDate.getTime()
      ){

        button.classList.add(
          "is-active"
        );

      }


      days.appendChild(
        button
      );

    }

  }


  /*=========================================================
    HORARIOS
  =========================================================*/

  function renderHours(){

    if(!hoursGrid){

      return;

    }


    /*=======================================================
      SIN FECHA
    =======================================================*/

    if(!selectedDate){

      hoursGrid.style.display =
        "none";


      if(hoursMessage){

        hoursMessage.style.display =
          "block";


        hoursMessage.textContent =
          "Primero selecciona una fecha";

      }


      return;

    }


    /*=======================================================
      MOSTRAR HORARIOS
    =======================================================*/

    hoursGrid.style.display =
      "grid";


    if(hoursMessage){

      hoursMessage.style.display =
        "none";

    }


    hoursGrid.innerHTML =
      "";


    hours.forEach(
      function(hour){

        const isOccupied =
          occupiedHours.includes(
            hour
          );


        const button =
          document.createElement(
            "button"
          );


        button.type =
          "button";


        button.className =
          "br-hour";


        /*=================================================
          HORA OCUPADA
        =================================================*/

        if(isOccupied){

          button.classList.add(
            "is-occupied"
          );


          button.disabled =
            true;


          button.innerHTML = `

            <span class="br-hour__time">
              ${hour}
            </span>

            <span class="br-hour__label">
              Ocupado
            </span>

          `;

        }


        /*=================================================
          HORA DISPONIBLE
        =================================================*/

        else{

          button.innerHTML = `

            <span class="br-hour__time">
              ${hour}
            </span>

          `;


          button.addEventListener(
            "click",
            function(){

              selectedHour =
                hour;


              bookingData.hour =
                hour;


              renderHours();

              updateBookingButton();

            }
          );


          /*===============================================
            HORA SELECCIONADA
          ===============================================*/

          if(
            selectedHour ===
            hour
          ){

            button.classList.add(
              "is-active"
            );

          }

        }


        hoursGrid.appendChild(
          button
        );

      }
    );


    /*=======================================================
      LEYENDA
    =======================================================*/

    let legend =
      booking.querySelector(
        ".br-hours__legend"
      );


    if(!legend){

      legend =
        document.createElement(
          "div"
        );


      legend.className =
        "br-hours__legend";


      legend.innerHTML = `

        <span class="br-hours__legend-box"></span>

        <span class="br-hours__legend-title">
          Ocupado
        </span>

        <span class="br-hours__legend-description">
          Este horario ya está reservado.
        </span>

      `;


      hoursGrid.insertAdjacentElement(
        "afterend",
        legend
      );

    }

  }


  /*=========================================================
    CONSULTAR DISPONIBILIDAD
  =========================================================*/

  async function loadAvailability(){

    if(!selectedDate){

      occupiedHours =
        [];


      renderHours();


      return;

    }


    const date =
      formatDate(
        selectedDate
      );


    if(hoursMessage){

      hoursMessage.style.display =
        "block";


      hoursMessage.textContent =
        "Consultando disponibilidad...";

    }


    hoursGrid.style.display =
      "none";


    try{

      const response =
        await fetch(
          BR_BOOKING_API +
          "?action=availability&date=" +
          encodeURIComponent(
            date
          )
        );


      const data =
        await response.json();


      console.log(
        "BR BOOKING — Disponibilidad:",
        data
      );


      if(!data.success){

        throw new Error(
          data.error ||
          "No se pudo consultar disponibilidad."
        );

      }


      occupiedHours =
        Array.isArray(
          data.occupied
        )
          ? data.occupied
          : [];


      /*===================================================
        SI LA HORA SELECCIONADA AHORA ESTÁ OCUPADA
      ===================================================*/

      if(
        selectedHour &&
        occupiedHours.includes(
          selectedHour
        )
      ){

        selectedHour =
          null;


        bookingData.hour =
          null;

      }


      renderHours();

      updateBookingButton();

    }


    catch(error){

      console.error(
        "BR BOOKING — Error disponibilidad:",
        error
      );


      occupiedHours =
        [];


      if(hoursGrid){

        hoursGrid.style.display =
          "none";

      }


      if(hoursMessage){

        hoursMessage.style.display =
          "block";


        hoursMessage.textContent =
          "No se pudo consultar la disponibilidad. Intenta nuevamente.";

      }

    }

  }


  /*=========================================================
    BOTÓN CONTINUAR
  =========================================================*/

  function updateBookingButton(){

    if(!bookingButton){

      return;

    }


    bookingButton.disabled =
      !(
        selectedDate &&
        selectedHour
      );

  }


  /*=========================================================
    CLICK CONTINUAR
  =========================================================*/

  if(bookingButton){

    bookingButton.addEventListener(
      "click",
      function(){

        if(
          !selectedDate ||
          !selectedHour
        ){

          return;

        }


        showBookingForm();

      }
    );

  }


  /*=========================================================
    MOSTRAR FORMULARIO
  =========================================================*/

  function showBookingForm(){

    /*=======================================================
      ELIMINAR FORMULARIO ANTERIOR
    =======================================================*/

    const existing =
      document.querySelector(
        ".br-booking-form"
      );


    if(existing){

      existing.remove();

    }


    /*=======================================================
      CREAR FORMULARIO
    =======================================================*/

    const form =
      document.createElement(
        "div"
      );


    form.className =
      "br-booking-form";


    form.innerHTML = `

      <div class="br-booking-form__overlay">

        <div class="br-booking-form__modal">

          <button
            type="button"
            class="br-booking-form__close"
            aria-label="Cerrar">

            ×

          </button>


          <span class="br-booking-form__eyebrow">
            AGENDA TU ASESORÍA
          </span>


          <h3 class="br-booking-form__title">
            Completa tus datos
          </h3>


          <p class="br-booking-form__text">
            Ya seleccionaste tu fecha y hora.
            Solo necesitamos tus datos para confirmar la solicitud.
          </p>


          <div class="br-booking-form__appointment">

            <div>

              <span>
                FECHA
              </span>


              <strong>
                ${formatBookingDate(
                  selectedDate
                )}
              </strong>

            </div>


            <div>

              <span>
                HORA
              </span>


              <strong>
                ${selectedHour}
              </strong>

            </div>

          </div>


          <form class="br-client-form">

            <label>

              Nombre

              <input
                type="text"
                name="name"
                required
                autocomplete="name"
                placeholder="Tu nombre">

            </label>


            <label>

              WhatsApp

              <input
                type="tel"
                name="phone"
                required
                autocomplete="tel"
                placeholder="10 dígitos">

            </label>


            <label>

              Correo electrónico

              <input
                type="email"
                name="email"
                required
                autocomplete="email"
                placeholder="tu@correo.com">

            </label>


            <button
              type="submit"
              class="br-form-submit">

              Confirmar asesoría

            </button>

          </form>

        </div>

      </div>

    `;


    document.body.appendChild(
      form
    );


    document.body.style.overflow =
      "hidden";


    /*=======================================================
      CERRAR FORMULARIO
    =======================================================*/

    const closeButton =
      form.querySelector(
        ".br-booking-form__close"
      );


    function closeForm(){

      form.remove();


      document.body.style.overflow =
        "";

    }


    closeButton.addEventListener(
      "click",
      closeForm
    );


    /*=======================================================
      CERRAR AL HACER CLICK FUERA
    =======================================================*/

    form
      .querySelector(
        ".br-booking-form__overlay"
      )
      .addEventListener(
        "click",
        function(event){

          if(
            event.target ===
            this
          ){

            closeForm();

          }

        }
      );


    /*=======================================================
      CERRAR CON ESC
    =======================================================*/

    document.addEventListener(
      "keydown",
      function escapeHandler(event){

        if(
          event.key ===
          "Escape"
        ){

          closeForm();


          document.removeEventListener(
            "keydown",
            escapeHandler
          );

        }

      }
    );


    /*=======================================================
      SUBMIT
    =======================================================*/

    const clientForm =
      form.querySelector(
        ".br-client-form"
      );


    clientForm.addEventListener(
      "submit",
      async function(event){

        event.preventDefault();


        /*===================================================
          OBTENER DATOS
        ===================================================*/

        const formData =
          new FormData(
            clientForm
          );


        bookingData.name =
          formData.get(
            "name"
          );


        bookingData.phone =
          formData.get(
            "phone"
          );


        bookingData.email =
          formData.get(
            "email"
          );


        bookingData.date =
          formatDate(
            selectedDate
          );


        bookingData.hour =
          selectedHour;


        console.log(
          "BR BOOKING ENVIANDO:",
          bookingData
        );


        /*===================================================
          BOTÓN
        ===================================================*/

        const submitButton =
          clientForm.querySelector(
            ".br-form-submit"
          );


        submitButton.disabled =
          true;


        submitButton.textContent =
          "Confirmando...";


        /*===================================================
          ENVIAR A GOOGLE APPS SCRIPT
        ===================================================*/

        try{

          const response =
            await fetch(
              BR_BOOKING_API,
              {

                method:
                  "POST",

                headers: {

                  "Content-Type":
                    "text/plain;charset=utf-8"

                },

                body:
                  JSON.stringify(
                    bookingData
                  )

              }
            );


          const result =
            await response.json();


          console.log(
            "BR BOOKING — RESPUESTA:",
            result
          );


          /*=================================================
            ERROR DEL SERVIDOR
          =================================================*/

          if(
            !result.success
          ){

            throw new Error(
              result.error ||
              "No se pudo registrar la cita."
            );

          }


          /*=================================================
            ÉXITO
          =================================================*/

          const modal =
            form.querySelector(
              ".br-booking-form__modal"
            );


          modal.innerHTML = `

            <div class="br-booking-success">

              <div class="br-booking-success__icon">
                ✓
              </div>


              <span class="br-booking-form__eyebrow">
                SOLICITUD RECIBIDA
              </span>


              <h3>
                ¡Tu asesoría está lista!
              </h3>


              <p>
                Hemos registrado tu solicitud.
                En breve nos pondremos en contacto
                contigo para confirmar tu cita.
              </p>


              <div class="br-booking-form__appointment">

                <div>

                  <span>
                    FECHA
                  </span>


                  <strong>
                    ${formatBookingDate(
                      selectedDate
                    )}
                  </strong>

                </div>


                <div>

                  <span>
                    HORA
                  </span>


                  <strong>
                    ${selectedHour}
                  </strong>

                </div>

              </div>


              <button
                type="button"
                class="br-form-submit br-booking-success__close">

                Listo

              </button>

            </div>

          `;


          /*=================================================
            BOTÓN LISTO
          =================================================*/

          const successClose =
            modal.querySelector(
              ".br-booking-success__close"
            );


          successClose.addEventListener(
            "click",
            closeForm
          );


        }


        /*===================================================
          ERROR DE CONEXIÓN
        =================================================*/

        catch(error){

          console.error(
            "BR BOOKING — ERROR AL GUARDAR:",
            error
          );


          submitButton.disabled =
            false;


          submitButton.textContent =
            "Confirmar asesoría";


          alert(
            "No pudimos registrar tu cita. Por favor intenta nuevamente."
          );

        }

      }
    );

  }


  /*=========================================================
    FORMATO FECHA PARA API
  =========================================================*/

  function formatDate(date){

    if(!date){

      return "";

    }


    const year =
      date.getFullYear();


    const month =
      String(
        date.getMonth() + 1
      ).padStart(
        2,
        "0"
      );


    const day =
      String(
        date.getDate()
      ).padStart(
        2,
        "0"
      );


    return (
      year +
      "-" +
      month +
      "-" +
      day
    );

  }


  /*=========================================================
    FORMATO FECHA VISIBLE
  =========================================================*/

  function formatBookingDate(date){

    if(!date){

      return "";

    }


    const options = {

      day:
        "numeric",

      month:
        "long",

      year:
        "numeric"

    };


    return date.toLocaleDateString(
      "es-MX",
      options
    );

  }

}